import { Button, Checkbox, Modal } from "antd";
import { WarningFilled } from "@ant-design/icons";
import { useState } from "react";
const ModalTitle = (
  <>
    <WarningFilled style={{ marginRight: "8px", color: "#f57c00" }} />
    Attenzione
  </>
);

const GpsPenaltyInfoModal = (props: { onOk: any; open: any }) => {
  const [isNoShowChecked, setIsNoShowChecked] = useState(false);
  const handleNoShowChange = (e: any) => {
    setIsNoShowChecked(e.target.checked);
  };

  return (
    <Modal
      title={ModalTitle}
      open={props.open}
      closable={false}
      footer={[
        <Button
          key="ok"
          type="primary"
          onClick={() => props.onOk(isNoShowChecked)}
        >
          OK
        </Button>,
      ]}
    >
      <p>
        Come da comunicazione PEC ricevuta in data 3 Agosto 2026, si ricorda
        che per i trasporti effettuati a partire dal 1 settembre 2026 è in
        vigore la penale GPS pari a €10,00 per trasporto, come previsto dai
        Termini & Condizioni.
      </p>
      <p>
        Vi invitiamo a verificare la corretta dotazione GPS dei mezzi,
        l’integrazione con il provider Co3 e l’inserimento completo dei dati
        su Orcas nei tempi richiesti.
      </p>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Checkbox onChange={handleNoShowChange}>Non mostrare più</Checkbox>
      </div>
    </Modal>
  );
};

export default GpsPenaltyInfoModal;
